import { useInfiniteQuery } from "react-query";

import { GetNotifyContentParamsType, getNotifyContentList } from "../../../queries/notify";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useAnonymousToken } from "../../auth/hooks/useAnonymousToken";
import identity from "../../../selectors/identity";
import { useAnonymousOrNormalNetworkHeaders } from "../../auth/hooks/useAnonymousOrNormalNetworkHeaders";

export function useInfiniteNotificationContent(params: GetNotifyContentParamsType) {
  const { isLoggedIn: isLoggedInAnonymously, identifier, token } = useAnonymousToken();
  const isLoggedIn = useSelector(identity.isLoggedIn);

  const headers = useAnonymousOrNormalNetworkHeaders();

  const subscriberContactMethodId =
    isLoggedIn && isLoggedInAnonymously() && token && identifier ? +identifier : undefined;

  const {
    data,
    isLoading: isNotificationContentLoading,
    isFetching: isNotificationContentFetching,
    fetchMore: fetchMoreNotificationContent,
    canFetchMore: canFetchMoreNotificationContent,
  } = useInfiniteQuery(
    buildNotifyInfiniteNotificationContentQueryKey(params, subscriberContactMethodId),
    getNotifyContentList(headers, subscriberContactMethodId),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      getFetchMore: (lastPage) => {
        return lastPage.data.at(-1)?.cursor?.join(",");
      },
      keepPreviousData: true,
    },
  );
  const notifyContent = useMemo(() => data?.flatMap(({ data }) => data) ?? [], [data]);

  const lastPage = data?.at(-1);

  return {
    total: lastPage?.total ?? 0,
    notifyContent,
    isNotificationContentLoading,
    isNotificationContentFetching,
    fetchMoreNotificationContent,
    canFetchMoreNotificationContent,
  };
}

export function buildNotifyInfiniteNotificationContentQueryKey(
  params?: GetNotifyContentParamsType,
  subscriberContactMethodId?: number | undefined,
) {
  if (!params) {
    return "useInfiniteNotificationContent";
  }
  return [
    "useInfiniteNotificationContent",
    subscriberContactMethodId === undefined
      ? { ...params, subscriberContactMethodId: subscriberContactMethodId }
      : params,
  ];
}
